/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveElectronicsContactsRequest
 */
export interface SaveElectronicsContactsRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    objectId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    email?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveElectronicsContactsRequest
     */
    isEmailVerified?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof SaveElectronicsContactsRequest
     */
    emailVerificationTimestamp?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SaveElectronicsContactsRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveElectronicsContactsRequest
     */
    isPhoneVerified?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof SaveElectronicsContactsRequest
     */
    phoneVerificationTimestamp?: Date | null;
}

/**
 * Check if a given object implements the SaveElectronicsContactsRequest interface.
 */
export function instanceOfSaveElectronicsContactsRequest(value: object): value is SaveElectronicsContactsRequest {
    return true;
}

export function SaveElectronicsContactsRequestFromJSON(json: any): SaveElectronicsContactsRequest {
    return SaveElectronicsContactsRequestFromJSONTyped(json, false);
}

export function SaveElectronicsContactsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveElectronicsContactsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'objectId': json['objectId'] == null ? undefined : json['objectId'],
        'email': json['email'] == null ? undefined : json['email'],
        'isEmailVerified': json['isEmailVerified'] == null ? undefined : json['isEmailVerified'],
        'emailVerificationTimestamp': json['emailVerificationTimestamp'] == null ? undefined : (new Date(json['emailVerificationTimestamp'])),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'isPhoneVerified': json['isPhoneVerified'] == null ? undefined : json['isPhoneVerified'],
        'phoneVerificationTimestamp': json['phoneVerificationTimestamp'] == null ? undefined : (new Date(json['phoneVerificationTimestamp'])),
    };
}

export function SaveElectronicsContactsRequestToJSON(json: any): SaveElectronicsContactsRequest {
    return SaveElectronicsContactsRequestToJSONTyped(json, false);
}

export function SaveElectronicsContactsRequestToJSONTyped(value?: SaveElectronicsContactsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectId': value['objectId'],
        'email': value['email'],
        'isEmailVerified': value['isEmailVerified'],
        'emailVerificationTimestamp': value['emailVerificationTimestamp'] === null ? null : ((value['emailVerificationTimestamp'] as any)?.toISOString()),
        'phone': value['phone'],
        'isPhoneVerified': value['isPhoneVerified'],
        'phoneVerificationTimestamp': value['phoneVerificationTimestamp'] === null ? null : ((value['phoneVerificationTimestamp'] as any)?.toISOString()),
    };
}

